import React from "react"

import FieldFormElementView from "../../../../../../render/form-elemnent-view"
import FieldPopover_FormComponent from "../../../../../popover/components/form/form-component"
import FieldPopover_InlineEditable from "../../../../../popover/render/inline-editable"
import FieldTimeSpent_Picker from "../../../render/picker"
import {ITimeSpentPopoverParent} from "../popover-parent"
import FieldTimeReported_AddFromPopover from "../../../render/my-time/add-from-popover"

const debug = false
// const debug = 'FieldTimeReported_PopoverIsBillable'

type Props = {
    onSubmit?   : callback,
    model       : any,
    parent      : FieldTimeSpent_Picker | FieldPopover_FormComponent | FieldPopover_InlineEditable | FieldTimeReported_AddFromPopover | ITimeSpentPopoverParent
}

export default function FieldTimeReported_PopoverIsBillable(props:Props) {


    const onChange = (isBillable: boolean) => {
        debug && console.log(debug, 'onChange', isBillable)

        const picker = props.parent as FieldTimeSpent_Picker | ITimeSpentPopoverParent
        picker.onIsBillableChange(isBillable)
    }

    return (
        <>
            <div className="flex-row-left-center h-30 m-t-15">

                <div className="ui5-txt-no-accent-tiny">Billable</div>

                <FieldFormElementView className = "h-36 flex-1 m-l-10"
                                      field     = {gd.fields.timeReport.isBillable}
                                      model     = {props.model}
                                      onChange  = {onChange}/>
            </div>
        </>
    )
}



